import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { Card, Grid } from 'core/components';
import React from 'react';
function PlanCardContainer(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Card, _extends({
    p: 2
  }, rest), /*#__PURE__*/React.createElement(Grid, {
    gridTemplateColumns: "2fr 1fr",
    gridTemplateRows: "1fr"
  }, children));
}
export default PlanCardContainer;